import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAdJSljEnwSZEQaB33kqHH8st7I-nnbdPI",
  authDomain: "socialblast-app.firebaseapp.com",
  projectId: "socialblast-app",
  storageBucket: "socialblast-app.firebasestorage.app",
  messagingSenderId: "682885090039",
  appId: "1:682885090039:web:2b0382a7972ef4326221f2",
  measurementId: "G-MQSG0B2MLK"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);